module.exports = __webpack_public_path__ + "media/images/emblems/Bovernier-blazono-08adeb4869825da57de7cb4460b32c45.png";